"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "PaginationControls", {
  enumerable: true,
  get: function get() {
    return _PaginationControls.default;
  }
});
Object.defineProperty(exports, "ThreadedRepliesHeader", {
  enumerable: true,
  get: function get() {
    return _ThreadedRepliesHeader.default;
  }
});

var _ThreadedRepliesHeader = _interopRequireDefault(require("./ThreadedRepliesHeader"));

var _PaginationControls = _interopRequireDefault(require("./PaginationControls"));